import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';


@Component({
    selector: 'myupdates-delivery',
    templateUrl: './delivery.component.html',
    styleUrls: ['./delivery.component.scss'],
    imports: [RouterOutlet],
    host: {
      style: 'display: contents;'
    }
})
export class DeliveryComponent {

  constructor() {  }

}
